// Tiny internal icons so @dfws/ui has no icon-library dependency. Same 1.5 stroke as Lucide used in the app.
import type { SVGProps } from "react";

const base = { width: 20, height: 20, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" } as const;

export const Check = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} aria-hidden {...p}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const Close = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} aria-hidden {...p}>
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

export const ChevronRight = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} aria-hidden {...p}>
    <path d="m9 18 6-6-6-6" />
  </svg>
);
